export const FILE_DETAIL_FILTER_QUERY_KEYS = {
  fileType: "fileType",
  facilityType: "facilityType",
  fusionResult: "fusionResult",
};

export const FILE_DETAIL_FILTER_VALUES = {
  fileType: ["image", "video"],
  facilityType: [
    "\uC804\uAE30\uC124\uBE44",
    "\uAC00\uC2A4\uC124\uBE44",
    "\uAE30\uACC4\uC124\uBE44",
  ],
  fusionResult: ["0", "1", "2", "3"],
};

const FILE_DETAIL_FILTER_KEYS = Object.keys(FILE_DETAIL_FILTER_QUERY_KEYS);

function toArray(value) {
  if (Array.isArray(value)) return value;
  if (value == null || value === "") return [];
  return String(value).split(",");
}

export function normalizeFileDetailFilters(filters = {}) {
  return FILE_DETAIL_FILTER_KEYS.reduce((acc, key) => {
    const allowedValues = new Set(FILE_DETAIL_FILTER_VALUES[key] ?? []);
    const values = toArray(filters[key])
      .map((item) => String(item ?? "").trim())
      .filter((item) => item && allowedValues.has(item));

    acc[key] = Array.from(new Set(values));
    return acc;
  }, {});
}

export function parseFileDetailFilterParam(value, key) {
  return normalizeFileDetailFilters({ [key]: value })[key] ?? [];
}

export function parseFileDetailFiltersFromSearchParams(searchParams) {
  const entries = FILE_DETAIL_FILTER_KEYS.reduce((acc, key) => {
    const queryKey = FILE_DETAIL_FILTER_QUERY_KEYS[key];
    acc[key] = searchParams?.get?.(queryKey) ?? "";
    return acc;
  }, {});

  return normalizeFileDetailFilters(entries);
}

export function serializeFileDetailFilterValues(values) {
  return toArray(values)
    .map((item) => String(item ?? "").trim())
    .filter(Boolean)
    .join(",");
}

export function countFileDetailFilters(filters = {}) {
  return Object.values(normalizeFileDetailFilters(filters)).reduce(
    (count, values) => count + values.length,
    0,
  );
}
